<template>
    <div style="height: 100%"  @click="IsShowHospitalChange+=1">
        <Box title="设置">
            <div class="content">
                <div class="items" @click="showDiaLog = true">
                    <span>仓库</span>
                    <span>{{$UserInfo.StoreName}}</span>
                    <img src="../../assets/img/right.png">
                </div>
                <div class="items" @click="$router.push('/changePassword')">
                    <span>修改密码</span>
                    <img src="../../assets/img/right.png">
                </div>
                <div class="items" @click="ChangeHospital" v-if="IsShowHospitalChange==3"><!--&& !PresentType-->
                    <span>医院选择</span>
                    <img src="../../assets/img/right.png">
                </div>
            </div>
            <div class="logout" @click="logOut">退出登录</div>
        </Box>
        <van-popup v-model="showDiaLog" position="bottom" :style="{ height: '50%', borderRadius: '10px 10px 0 0'}">
            <div class="picker-header">
                <span @click="showDiaLog = false">取消</span>
                <span @click="confirm">确定</span>
            </div>
            <van-picker :columns="actions" @cancel="showPicker = false" @change="onChange" :default-index="actionsDefaultIndex"
                item-height="15vw" swipe-duration="500" />
        </van-popup>
    </div>
</template>

<script>
    import {PresentType} from '../../../config/index.js'
    import Box from '@/components/commonBox/commonBox'
    import Vue from 'vue';
    import {
        Popup,
        Picker
    } from 'vant';
    export default {
        name: 'setting',
        data() {
            return {
                showDiaLog: false, //  是否显示弹窗
                actions: [], //  滑块选项
                selectActions: '', //  选中的仓库
                actionsDefaultIndex: 1, //  滑块初始选中index
                vStoreList: null, //仓库集合对象
                IsShowHospitalChange:0,//医院选择是否显示
                PresentType:PresentType,//是否H5模式
            }
        },
        components: {
            Box,
            [Popup.name]: Popup,
            [Picker.name]: Picker
        },
        mounted() {
            this.loadSTORE();
        },
        methods: {
            logOut() {
                //  注销时 清空store和缓存后 刷新页面
                this.$store.commit('SET_WAREHOUSELIST',[]);
                this.$store.commit('SET_USER_INFO', {})
                localStorage.removeItem('userInfo')
                this.$router.replace({name:'Login'});
            },
            onChange(picker, value, index) {
                this.selectActions = value
            },
            confirm() {
                for (let i = 0; i < this.$store.getters.WarehouseList.length; i++) {
                    if (this.$store.getters.WarehouseList[i].StoreName===this.selectActions) {
                        this.$UserInfo.StoreCode=this.$store.getters.WarehouseList[i].StoreId;
                        this.$UserInfo.StoreName=this.$store.getters.WarehouseList[i].StoreName;
                        localStorage.setItem('userInfo',JSON.stringify(this.$UserInfo));
                        Vue.prototype.$UserInfo=this.$UserInfo;//此处赋值全局变量目的在于更新仓库
                        this.showDiaLog=false;
                        break;
                    }
                }
            },
            loadSTORE() {
                if(this.$store.getters.WarehouseList.length===0){
                    this.$get('/api/Login/WarehouseList',{
                                UserCode: this.$UserInfo.UserId,
                                Token: 'YTDF5EF3A6174564E5981A446158F106'
                        })
                        .then(result => {
                            if(result.Status){
                                this.$store.commit('SET_WAREHOUSELIST', result.WarehouseList);
                                this.CirculationWarehouseList();
                            }else this.$Toast("数据异常,请联系管理员!");
                        })
                }else this.CirculationWarehouseList();
            },loadStoreDefault(){//获取仓库完成加载默认第一个仓库
                let vIndex=this.actions.findIndex(e => e==this.$UserInfo.StoreName)
                this.actionsDefaultIndex =vIndex==-1?0:vIndex;
                this.selectActions=this.actions[this.actionsDefaultIndex];
            },CirculationWarehouseList(){//循环仓库列表
                 for(let i=0;i<this.$store.getters.WarehouseList.length;i++){
                     this.actions.push(this.$store.getters.WarehouseList[i].StoreName)
                 }
                 this.loadStoreDefault();//选中/以及
            },ChangeHospital(){//重新选择医院代码
                this.$store.commit('SET_WAREHOUSELIST',[]);//清除状态管理的信息以及缓存
                this.$store.commit('SET_USER_INFO', {});
                localStorage.removeItem('userInfo');
                localStorage.removeItem('HospitalUrl');
                this.$router.replace({name:'Hospital'});//跳转医院页/不留route记录
            }
        }
    }
</script>

<style scoped lang="scss">
    .content {
        margin-top: 80px !important;
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 28px 0 40px !important;
        box-sizing: border-box;

        .items {
            display: flex;
            height: 110px;
            border-bottom: 2px solid #F3F3F3;
            font-size: 29px;
            color: $TEXT-DARK-COLOR;
            align-items: center;

            span {
                &:first-child {
                    flex: 1;
                }
            }

            img {
                width: 32px;
                margin-left: 6px;
            }

            &:last-child {
                border: none
            }
        }
    }

    .logout {
        width: 710px;
        height: 96px;
        text-align: center;
        line-height: 96px;
        background: #4FA69E;
        border-radius: 8px;
        margin: auto;
        margin-top: 57px;
        font-size: 30px;
        color: #FFFFFF;
    }
</style>



// WEBPACK FOOTER //
// src/page/setting/setting.vue